import Footer from "../../../components/doctorComponents/footer";
import HeaderWithMenu from "../../../components/doctorComponents/headerWithMenu";
import Button2 from "../../../components/doctorComponents/buttons/button-2";
import PreRegisterBanner from "../../../components/doctorComponents/banners/pre-register-banner";
import { getUserInfo } from "../../../services/doctorServices/authService";
import RegisterHeader from "../../../components/doctorComponents/header/register-header";
import { useHistory } from "react-router-dom";

const Doctor500 = () => {
  const userlogin = getUserInfo();
  let history = useHistory();

  return (
    <>
      {userlogin !== null && (
        <HeaderWithMenu img="/doctor/menu-mobile-pattern.png" />
      )}
      {userlogin === null && <PreRegisterBanner />}
      {userlogin === null && (
        <RegisterHeader img="/doctor/bg-mobile-pattern.png" />
      )}
      <div className="container">
        <div className="error-inner-container">
          <div className="div-center">
            <p className="error-title-1">ERROR</p>
            <p className="error-title-2">500</p>
            <p>
              Lo sentimos, ha ocurrido un error interno en el servidor y ya
              estamos solucionándolo. Si necesita ayuda inmediata por favor
              contacte al administrador.
            </p>
            <Button2 label="Ir al inicio" onClick={()=>history.push('/doctor/dashboard')}/>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Doctor500;
